export default {
  geolocation: {
    lat: '55.6761',
    lng: '12.5683',
    label: '1000 Copenhagen',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
